import React, { ReactElement } from 'react';
import { useAtomValue } from 'jotai/index';
import { Strip } from '../../Models/Article';
import { FetchReadingProgressAtom } from '../../store/ReadingProgressStore';
import { readerReadableUrlOrDefault } from '../../utils/utils';
import KodanshaResume from '../KodanshaUIKit/KodanshaResume/KodanshaResume';
import './ContinueReadingGridStrip.scss';

interface ContinueReadingGridStripProps {
    strip: Strip;
}

interface ContinueReadingGridStripParams {
    showCount: number;
}

export function ContinueReadingGridStrip({ strip: { params } }: ContinueReadingGridStripProps): ReactElement | null {
    const { showCount } = params as ContinueReadingGridStripParams;
    const readingProgress = useAtomValue(FetchReadingProgressAtom);
    if (readingProgress.length === 0) return null;
    return (
        <section className='ContinueReadingGridStrip'>
            <h2>Continue Reading</h2>
            <div className='ContinueReadingGridStrip-items'>
                {readingProgress.slice(0, showCount).map(item => (
                    <div key={item.comicId} className='ContinueReadingGridStrip-item'>
                        <KodanshaResume
                            readingProgress={item.readingProgress}
                            chapterName={item.comicName}
                            chapterNumber={item.chapterNumber}
                            volumeNumber={item.volumeNumber}
                            productType={item.productType}
                            seriesId={item.seriesId}
                            readableUrl={item.readableUrl}
                            seriesReadableUrl={item.seriesReadableUrl}
                            src={item.thumbnailURL}
                            id={item.comicId}
                            readerLink={readerReadableUrlOrDefault(item)}
                        />
                    </div>
                ))}
            </div>
        </section>
    );
}
